import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('App ErrorBoundary caught:', error, info);
    this.setState({ info });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    const isDark = (() => {
      try { return localStorage.getItem('task_theme') === 'dark'; } catch { return false; }
    })();
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: isDark ? '#0b1020' : '#f8fafc', color: isDark ? '#e5e7eb' : '#0f172a',
        fontFamily: 'Inter, system-ui, sans-serif', padding: 24
      }}>
        <div style={{
          maxWidth: 560, width: '100%',
          background: isDark ? 'rgba(255,255,255,0.04)' : '#fff',
          border: isDark ? '1px solid rgba(255,255,255,0.08)' : '1px solid #e5e7eb',
          borderRadius: 16, padding: 28,
        }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>⚠️</div>
          <h1 style={{ fontSize: 20, fontWeight: 700, margin: '0 0 6px' }}>Something went wrong</h1>
          <p style={{ fontSize: 13, opacity: 0.7, margin: '0 0 16px' }}>
            The page hit an unexpected error. Try refreshing — if it keeps happening, contact support with the details below.
          </p>
          {this.state.error && (
            <pre style={{
              background: isDark ? 'rgba(0,0,0,0.35)' : '#f1f5f9', color: isDark ? '#fca5a5' : '#b91c1c',
              borderRadius: 8, padding: 12, fontSize: 11, overflow: 'auto', maxHeight: 200, margin: '0 0 16px',
            }}>
              {String(this.state.error?.message || this.state.error)}
            </pre>
          )}
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={this.handleReload} data-testid="err-reload" style={{
              flex: 1, background: '#2563eb', color: '#fff', border: 'none', borderRadius: 10,
              padding: '10px 16px', fontWeight: 600, cursor: 'pointer',
            }}>Refresh page</button>
            <button onClick={this.handleHome} data-testid="err-home" style={{
              flex: 1, background: 'transparent', color: isDark ? '#e5e7eb' : '#0f172a',
              border: isDark ? '1px solid rgba(255,255,255,0.15)' : '1px solid #cbd5e1', borderRadius: 10,
              padding: '10px 16px', fontWeight: 600, cursor: 'pointer',
            }}>Go home</button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
